import React from 'react';
import PropTypes from 'prop-types';
import { keys, values, merge } from 'lodash';
import { FlexLoadingSpinner } from 'components/helpers/LoadingSpinner';
import { Line } from 'react-chartjs-2';
import { formatChartDate } from 'utils/Formatters';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  ChartDataLabels
);

const COLORS = {
  account: [
    {
      backgroundColor: 'rgba(245,166,35,0.4)',
      borderColor: 'rgba(245,166,35,1)',
      pointBorderColor: 'rgba(245,166,35,1)',
      pointHoverBackgroundColor: 'rgba(245,166,35,1)',
    },
    {
      backgroundColor: 'rgba(201,24,211,0.4)',
      borderColor: 'rgba(201,24,211,1)',
      pointBorderColor: 'rgba(201,24,211,1)',
      pointHoverBackgroundColor: 'rgba(201,24,211,1)',
    },
  ],
  engagement: [
    {
      backgroundColor: 'rgba(201,24,211,0.4)',
      borderColor: 'rgba(201,24,211,1)',
      pointBorderColor: 'rgba(201,24,211,1)',
      pointHoverBackgroundColor: 'rgba(201,24,211,1)',
    },
  ],
};

const LINECHART_DEFAULT = {
  label: '',
  fill: 'origin',
  lineTension: 0.1,
  borderCapStyle: 'butt',
  borderDash: [],
  borderDashOffset: 0.0,
  borderJoinStyle: 'miter',
  pointBackgroundColor: '#fff',
  pointBorderWidth: 1,
  pointHoverRadius: 5,
  pointHoverBorderColor: 'rgba(220,220,220,1)',
  pointHoverBorderWidth: 2,
  pointRadius: 3,
  pointHitRadius: 10,
};

const chartData = (data, chartType) => {
  const datasets = data.map((d, i) => merge({}, LINECHART_DEFAULT, COLORS[chartType][i], { data: values(d.data), label: d.label }),);
  return {
    labels: keys(data[0].data).map(d => formatChartDate(d)),
    datasets,
  };
}

const CHART_OPTIONS = {
  legend: { display: true },
  maintainAspectRatio: false,
  plugins: {
    datalabels: {
      display: false,
    },
  },
  scales: {
    x: { gridLines: { display: false } },
    y: { position: 'right', scalePositionLeft: false, ticks: { min: 0, suggestedMax: 10 } },
  },
};


const LineChart = ({ data, chartType, title, cls, isLoading }) => {
  if (isLoading) {
    return (
      <div className={`${cls || ''} o-dashboard-card__wrap`}>
        {title ? <strong>{title}</strong> : <strong><span style={{ visibility: 'hidden' }}>Title</span></strong>}
        <div className='o-dashboard-card u-padding-bottom--small cs-bg--light'>
          <div className='column'>
            <div className='o-chart--line'>
              <FlexLoadingSpinner />
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={`${cls || ''} o-dashboard-card__wrap`}>
      {title ? <strong>{title}</strong> : <strong><span style={{ visibility: 'hidden' }}>Title</span></strong>}
      <div className='o-dashboard-card u-padding-bottom--small cs-bg--light'>
        <div className='column'>
          <div className='o-chart--line'>
            <Line data={chartData(data, chartType)} options={CHART_OPTIONS} />
          </div>
        </div>
      </div>
    </div>
  )
}


LineChart.propTypes = {
  chartType: PropTypes.string.isRequired,
  cls: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  title: PropTypes.string.isRequired,
  meta: PropTypes.object,
  options: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
}

export default LineChart;
